// extracted by mini-css-extract-plugin
export var defaultWrapper = "_hw-3";
export var downloadButton = "_hw-4";
export var fileContainer = "_hw-9 _hw-7";
export var fileContainerBase = "_hw-7";
export var fileContainerBaseSm = "_hw-a _hw-7";
export var fileContainerFixedHeight = "_hw-8 _hw-7";
export var fileContainerFixedHeightSm = "_hw-c _hw-a _hw-7";
export var fileContainerSm = "_hw-b _hw-a _hw-7";
export var fileInfo = "_hw-5";
export var fileInfoWidthRestricted = "_hw-6";
export var fileType = "_hw-1";
export var fileTypeName = "_hw-2";
export var fileTypeSm = "_hw-d _hw-1";
export var image = "_hw-0";
export var link = "_hw-f";
export var overflowEllipsis = "_hw-e";